import { GetFollowersResponse, GetFollowingInfoResponse } from '@/types/Activity'
import { useMutation, useQuery } from '@tanstack/react-query'
import httpService from './httpService'

const activityPath = '/activity/v1.1'

enum ActivityQueryKeys {
  GET_FOLLOWINGS = 'get_followings',
  GET_FOLLOWERS = 'get_followers',
  GET_FOLLOWING_INFO = 'get_following_info',
}

export const useGetFollowings = (
  playerId?: number,
  limit?: number,
  offset?: number,
  token?: string,
  isActive?: boolean
) => {
  return useQuery(
    [ActivityQueryKeys.GET_FOLLOWINGS, playerId, limit, offset, isActive, token],
    async () => {
      return await httpService.Get<GetFollowersResponse>(
        `${activityPath}/user/${playerId}/followings?limit=${limit}&offset=${offset}`
      )
    },
    {
      enabled: !!playerId && !!token && isActive,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )
}

export const useGetFollowers = (
  playerId?: number,
  limit?: number,
  offset?: number,
  token?: string,
  isActive?: boolean
) => {
  return useQuery(
    [ActivityQueryKeys.GET_FOLLOWERS, playerId, limit, offset, isActive, token],
    async () => {
      return await httpService.Get<GetFollowersResponse>(
        `${activityPath}/user/${playerId}/followers?limit=${limit}&offset=${offset}`
      )
    },
    {
      enabled: !!playerId && !!token && isActive,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )
}

export const useGetFollowingInfo = (playerId?: number, token?: string) => {
  return useQuery(
    [ActivityQueryKeys.GET_FOLLOWING_INFO, playerId, token],
    async () => {
      return await httpService.Get<GetFollowingInfoResponse>(`${activityPath}/user/${playerId}/followingInfo`)
    },
    {
      enabled: !!playerId && !!token,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )
}

export const useFollow = () => {
  return useMutation([], async (playerId: number) => {
    const res = await httpService.Post(`${activityPath}/user/${playerId}/follow`, {})
    return res as any
  })
}

export const useUnfollow = () => {
  return useMutation([], async (playerId: number) => {
    const res = await httpService.Delete(`${activityPath}/user/${playerId}/follow`)
    return res as any
  })
}
